module.exports = __webpack_public_path__ + "static/wheelChair-cdee7b1644d6b6b1bba8c5be3674e613.jpg";